import { createFileRoute } from '@tanstack/react-router'
import CriteriaQc from '@/components/smartqc-route/criteria/index.jsx'
import { navigateGuard } from '@/utils/auth.js'
import { UserRole } from '@/constants/user.js'

export const Route = createFileRoute('/_auth/smart-qc/criteria/')({
  beforeLoad: ({ location }) => {
    return navigateGuard(location, [UserRole.ADMINISTRATOR])
  },
  component: CriteriaQc,
})
